import React from "react";

export default function MenuSearchForm({ homeUrl }) {
  if (homeUrl == "/") homeUrl = "";
  return (
    <form
      className="menu-search-form"
      action={`${homeUrl}/search`}
      method="GET"
    >
      <div className="form-control search-field">
        <label className="visually-hidden" htmlFor="menu-search-input">
          Søk
        </label>
        <div>
          <input
            id="menu-search-input"
            type="text"
            name="q"
            placeholder="Søk"
          />
        </div>
        <button type="submit" className="btn" aria-label="Søk">
          Søk
        </button>
      </div>
    </form>
  );
}
